import React, { PropTypes } from 'react';
import ProductItem from './ProductItem';

const PointItem = ({ id, point }) => {
  const renderProducts = () => {
    if (point.products.length) {
      return (
        <table className="ui table">
          <thead>
            <tr className="background states">
              <td colSpan="8">
                <strong>{point.name}</strong>
              </td>
            </tr>
            <tr className="">
              <th className="ten wide">Produit</th>
              <th className="six wide">Manipulation</th>
            </tr>
          </thead>
          <tbody>
            {point.products.map(p => (
              <ProductItem key={p.id} product={p} />
            ))}
          </tbody>
        </table>
      );
    }
    return (
      <table className="ui table">
        <thead>
          <tr className="background states">
            <td colSpan="8">
              <strong>{point.name}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <div className="ui message">Aucun produit associé à ce poste</div>
        </tbody>
      </table>
    );
  };

  return renderProducts();
};

PointItem.propTypes = {
  point: PropTypes.object.isRequired,
};

export default PointItem;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/PointItem.js